import { fadeIn } from "../../../../scripts/animations";
import barba from "@barba/core";
import barbaPrefetch from "@barba/prefetch";
import {
  TRANSITION_PRODUCT_VIEW_AFTER,
  TRANSITION_PRODUCT_VIEW_AFTER_ENTER,
  TRANSITION_PRODUCT_VIEW_BEFORE,
  TRANSITION_PRODUCT_VIEW_LEAVE,
} from "./constants";
import { isBarbaLink } from "../../Product/ProductForm/product-form";

export const useProductView = () => {
  if (document.documentElement.dataset.prefetching === "false") {
    return;
  }
  barba.use(barbaPrefetch);
  barba.init({
    prevent: ({ el }) => el.hasAttribute("data-transition-type") === false,
    views: [
      {
        namespace: "product",
      },
    ],
    transitions: [
      {
        name: "wave-under",
        from: {
          namespace: ["product"],
          custom: ({ trigger }) => {
            if (trigger === "back" || trigger === "forward") {
              // if back/forward browser buttons are used do not trigger wave tranisition
              return false;
            } else if (isBarbaLink(trigger)) {
              return (
                trigger.hasAttribute("data-transition-type") &&
                trigger.dataset.transitionType === "wave-under"
              );
            }

            return false;
          },
        },
        sync: true,
        before(data) {
          window.dispatchEvent(
            new CustomEvent(TRANSITION_PRODUCT_VIEW_BEFORE, {
              detail: data,
            })
          );
        },
        enter(data) {
          fadeIn(data.next.container);
        },
        leave(data) {
          window.dispatchEvent(
            new CustomEvent(TRANSITION_PRODUCT_VIEW_LEAVE, {
              detail: data,
            })
          );
        },
        after(data) {
          window.dispatchEvent(
            new CustomEvent(TRANSITION_PRODUCT_VIEW_AFTER, {
              detail: data,
            })
          );

          window.dispatchEvent(
            new CustomEvent("shopify:section:load", {
              detail: data,
            })
          );

          document.dispatchEvent(new Event("recharge:reload"));
          if (window.Rebuy && window.Rebuy.SmartCart) {
            window.Rebuy.SmartCart.bindEvents();
          }
        },
        afterEnter(data) {
          window.dispatchEvent(
            new CustomEvent(TRANSITION_PRODUCT_VIEW_AFTER_ENTER, {
              detail: data,
            })
          );
        },
      },
    ],
  });
};
